module.exports = "/DesktopModules/Cantarus/StencilDisplay/Clients/assets/logo.png";